import React from 'react'

const Network = React.lazy(async () => ({
    default: (await import('@oc/network/module')).Network
}))

export function NetworkComponent() {
    return (
        <React.Suspense fallback={null}>
            <Network />
        </React.Suspense>
    )
}
